import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1 .6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M19.38 20A11.6 11.6 0 0 0 21 14l-9-4-9 4c0 2.9.94 5.34 2.81 7.76",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 10v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 2v3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Ship";
const Ship = memo(themed(Icon));
export {
  Ship
};
//# sourceMappingURL=ship.js.map
